import React from 'react';
import styled from 'styled-components';

import Body2 from '@joinforma/ui/components/Body2';
import Title2 from '@joinforma/ui/components/Title2';

import { ReactComponent as AlertCircleIcon } from '@joinforma/ui/assets/icons/exclamation-mark.svg';

import { SCREEN_WIDTHS } from '@joinforma/ui/constants/breakpoints';

const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.background.secondary};
`;

const Container = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: auto;
  padding: 12px;

  @media (min-width: ${SCREEN_WIDTHS.MOBILE_PORTRAIT}) {
    align-items: center;
    flex-direction: row;
  }

  @media (min-width: ${SCREEN_WIDTHS.TABLET_PORTRAIT}) {
    align-items: center;
    flex-direction: row;
  }
`;

const InfoTextContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${SCREEN_WIDTHS.MOBILE_PORTRAIT}) {
    display: block;
    margin-left: 14px;
  }
`;
const InfoText = styled(Title2)``;

const BankLinkText = styled(Body2)`
  display: inline;
  color: ${({ theme }) => theme.colors.text.link};
`;

const CipDocumentUploadBanner = ({
  bankApplicationFormUrl,
}: {
  bankApplicationFormUrl?: string;
}) => {
  const getBannerText = () =>
    'To finish opening your HSA, upload documents to verify your identity.';

  return (
    <Card>
      <Container>
        <AlertCircleIcon />
        <InfoTextContainer>
          <InfoText>{getBannerText()}</InfoText>
          <a href={bankApplicationFormUrl} target="_blank" rel="noreferrer">
            <BankLinkText> Upload documents</BankLinkText>
          </a>
        </InfoTextContainer>
      </Container>
    </Card>
  );
};

export default CipDocumentUploadBanner;
